import { ADDRESS_TYPES } from 'platform/forms/address/helpers';
import { parseISODate } from 'platform/forms-system/src/js/helpers';
import { isValidDate } from 'platform/forms-system/src/js/utilities/validations';

/**
 * Checks for a full date string and does not allow partial dates.
 * @returns Returns **true** if every field (day, month, year) is non-empty, **false** otherwise.
 */
export const isValidFullDate = dateString => {
  if (!dateString) return false;

  const { day, month, year } = parseISODate(dateString);

  return isValidDate(day, month, year);
};

/**
 * Validates that the start date is non-empty and comes before the end date.
 * @returns Adds 3 possible error messages. *1.* The start date is not a valid full date. *2.* The start date comes after the end date. *3.* The start and end date are the same.
 */
export const validatePrepCourseStartDate = (errors, fieldData, formData) => {
  if (!fieldData) return;

  if (!isValidFullDate(fieldData)) errors.addError('Enter a valid date');

  if (!isValidFullDate(formData.prepCourseEndDate)) return;

  const start = new Date(formData.prepCourseStartDate);
  const end = new Date(formData.prepCourseEndDate);

  if (end < start) {
    errors.addError('The start date cannot be after the end date');
  }
  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate()
  ) {
    errors.addError('The start date and end date cannot be the same');
  }
};

/**
 * Validates that the entire end date is non-empty.
 * @returns Adds custom error message if any field (day, month, year) is empty.
 */
export const validatePrepCourseEndDate = (errors, dateString) => {
  if (!dateString) return;
  if (!isValidFullDate(dateString)) errors.addError('Enter a valid date');
};

export const todaysDate = () => {
  const date = new Date();
  const offset = date.getTimezoneOffset();
  const today = new Date(date.getTime() - offset * 60 * 1000);
  return today.toISOString().split('T')[0];
};

export const transformPhoneNumberObject = (phone = {}) => {
  const { isInternational, areaCode, phoneNumber, countryCode, extension } =
    phone;

  if (!phoneNumber || !areaCode) {
    return null;
  }

  let formattedPhoneNumber = phoneNumber;
  if (!isInternational) {
    formattedPhoneNumber = `${phoneNumber.substring(
      0,
      3,
    )}-${phoneNumber.substring(3)}`;
  }

  let base = `${areaCode}-${formattedPhoneNumber}`;
  if (isInternational && countryCode) {
    base = `+${countryCode} ${base}`;
  }

  if (extension) {
    base = `${base} x${extension}`;
  }

  return base;
};

export const transformMailingAddress = (addr = {}) => {
  const {
    addressType,
    addressLine1,
    addressLine2,
    addressLine3,
    city,
    countryCodeIso3,
    stateCode,
    internationalPostalCode,
    province,
    zipCode,
  } = addr;

  return {
    isMilitary: addressType === ADDRESS_TYPES.military,
    street: addressLine1,
    street2: addressLine2,
    street3: addressLine3,
    city,
    state: addressType === ADDRESS_TYPES.international ? province : stateCode,
    postalCode:
      addressType === ADDRESS_TYPES.international
        ? internationalPostalCode
        : zipCode,
    country: countryCodeIso3,
  };
};
